import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { PageHeader, GlassCard, GradButton } from "@/components/erp";
import { Th, BosDurum } from "@/components/ortak/Liste";
import { useAuth } from "@/context/AuthContext";
import api, { errMsg } from "@/lib/api";

export default function Operasyonlar() {
  const { isYonetim } = useAuth();
  const [list, setList] = useState([]);
  const [ad, setAd] = useState("");
  const [hepsi, setHepsi] = useState(false);
  const yukle = () => api.get("/operasyonlar").then((r) => setList(r.data));
  useEffect(() => { yukle(); }, []);
  const ekle = async () => {
    if (!ad.trim()) return;
    try { await api.post("/operasyonlar", { ad: ad.trim().toLocaleUpperCase("tr-TR"), sira: list.length + 1, aktif: true }); setAd(""); yukle(); } catch (e) { toast.error(errMsg(e)); }
  };
  const guncelle = async (o, p) => { try { await api.put(`/operasyonlar/${o.id}`, { ad: o.ad, sira: o.sira, aktif: o.aktif, ...p }); yukle(); } catch (e) { toast.error(errMsg(e)); } };
  const sil = async (o) => { if (!window.confirm(`${o.ad} silinsin mi?`)) return; try { await api.delete(`/operasyonlar/${o.id}`); yukle(); } catch (e) { toast.error(errMsg(e)); } };
  const gorunen = list.filter((o) => hepsi || o.aktif !== false);
  return (
    <div data-testid="operasyonlar-page">
      <PageHeader title="Operasyonlar" desc="Ürün kartındaki Operasyonlar sekmesinde istasyon ve süreyle birlikte kullanılır.">
        <label className="flex items-center gap-2 text-sm"><Switch data-testid="operasyon-hepsi" checked={hepsi} onCheckedChange={setHepsi} />Hepsini Göster</label>
      </PageHeader>
      {isYonetim && <div className="flex gap-2 mb-4 max-w-lg"><Input data-testid="operasyon-ad" className="bg-white/5" placeholder="Yeni operasyon adı (ör. HAMUR YOĞURMA)" value={ad} onChange={(e) => setAd(e.target.value)} onKeyDown={(e) => e.key === "Enter" && ekle()} />
        <GradButton data-testid="operasyon-ekle" onClick={ekle}><Plus className="w-4 h-4" />Yeni</GradButton></div>}
      <GlassCard className="p-4">{gorunen.length === 0 ? <BosDurum text="Henüz operasyon yok." testid="operasyon-bos" /> : (
        <table className="w-full text-sm"><thead><tr><Th>Operasyon</Th><Th className="w-24">Aktif</Th>{isYonetim && <Th className="w-12" />}</tr></thead>
          <tbody>{gorunen.map((o) => <tr key={o.id} className="border-t border-white/5" data-testid={`operasyon-satir-${o.id}`}>
            <td className="p-2.5 text-sm font-semibold">{o.ad}</td>
            <td className="p-2.5"><Switch data-testid={`operasyon-aktif-${o.id}`} disabled={!isYonetim} checked={o.aktif !== false} onCheckedChange={(v) => guncelle(o, { aktif: v })} /></td>
            {isYonetim && <td className="p-2.5"><button data-testid={`operasyon-sil-${o.id}`} onClick={() => sil(o)} className="p-1.5 rounded text-red-300 hover:bg-red-500/10"><Trash2 className="w-4 h-4" /></button></td>}
          </tr>)}</tbody></table>)}
      </GlassCard>
    </div>
  );
}
